import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useGlobalContext } from '../../contexts/GlobalContext';
import RoutesApp from '../../routes';

//Servicios
import { ManagerService } from '../../services/api';

//Componentes
import ManagersList from './ManagersList';

//Estilos
import right_arrow from '../../assets/imgs/next.png';
import Spinner from '../../components/spinner/Spinner';

function ManagersContainer() {
    const { token, user } = useGlobalContext();

    const [loader, setLoader] = useState(false);
    const [myManagersList, setMyManagersList] = useState([]);

    const Navigate = useNavigate();

    useEffect(() => {
        const getMyManagers = async () => {
            try {
                setLoader(true);

                const myManagers = await ManagerService.all({
                    token,
                    usuarioId: user.id,
                });

                if (myManagers) {
                    setTableData(buildTableData(myManagers.data));
                    setMyManagersList(myManagers.data);
                }

                setLoader(false);
            } catch (err) {
                setLoader(false);
                return err;
            }
        };

        getMyManagers();
    }, []);

    const buildTableData = (
        data = [{ id: 1, nombre: '', apellido: '', celular: '', icons: '' }]
    ) => {
        return {
            title: 'Mis Encargados',
            headers: ['Nombre', 'Apellido', 'Celular', ''],
            pagination: 10,
            data: data?.map((u) => {
                return {
                    nombre: u.nombre,
                    apellido: u.apellido,
                    celular: u.celular,
                    icons: (
                        <div>
                            <Link
                                to={RoutesApp.Managers.single + u.id}
                                className="table-icon_container"
                            >
                                <img
                                    className="table-icon"
                                    src={right_arrow}
                                    title="Visualizar"
                                    alt="Visualizar"
                                />
                            </Link>
                        </div>
                    ),
                };
            }),
        };
    };

    const [tableData, setTableData] = useState(buildTableData());

    return loader ? (
        <Spinner />
    ) : (
        <ManagersList states={{ tableData, myManagersList }} />
    );
}

export default ManagersContainer;
